import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFastTextField } from 'src/components/mui-overrides/Textfield';
import { useAssetType } from '../../../context-providers/asset-type/AssetTypeContext';

interface Props {
  disabled?: boolean;
}

export const RealestateSizeTextField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const { assetType } = useAssetType();
  const label =
    assetType === 'builderOwnerModel'
      ? t('dashboard.assets.addedit.main.generalinfo.fields.usableArea.label')
      : t('dashboard.assets.addedit.main.generalinfo.fields.size.label');
  return (
    <>
      <DefaultFastTextField
        disabled={disabled}
        type="number"
        label={label}
        fieldName="propertyDetails.size"
        placeholder={t('dashboard.assets.addedit.main.generalinfo.fields.size.placeholder')}
      />
    </>
  );
};
